const NAMESPACE = 'COMMENTS';
const ACTIONS = {
    MODAL_CLOSE: `${NAMESPACE}_MODAL_CLOSE`,
    MODAL_OPEN: `${NAMESPACE}_MODAL_OPEN`
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    close: () => ({type: ACTIONS.MODAL_CLOSE}),
    open: ({baseLocation, boardId, endDate, listingId, startDate, ...rest}) => ({
        type: ACTIONS.MODAL_OPEN,
        payload: {baseLocation, boardId, endDate, listingId, startDate, ...rest}
    })
};

export default {...ACTIONS, ...ACTION_CREATORS};



// WEBPACK FOOTER //
// ./src/universal/tripboard/comments/actions.js